import { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export default function InsuranceBadge({ text, src, className = "" }) {
  const [open, setOpen] = useState(false);
  if (!text) return null;
  return (
    <>
      <button
        type="button"
        onClick={() => src && setOpen(true)}
        className={`inline-flex items-center gap-2 transition-colors duration-200 ${
          src ? "hover:text-sky cursor-pointer" : "cursor-default"
        } ${className}`}
        data-testid="insurance-badge"
      >
        <ShieldCheck className="h-4 w-4 text-sky shrink-0" />
        <span className={src ? "underline decoration-sky/40 underline-offset-4" : ""}>{text}</span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl bg-navy border-white/10 p-3" data-testid="insurance-certificate-dialog">
          <p className="px-2 pt-2 pb-1 font-mono text-[10px] tracking-[0.25em] uppercase text-sky">
            Certificate of Liability Insurance
          </p>
          {src && (
            <img src={src} alt="Certificate of Liability Insurance — Perez Osorio Painting Services"
              className="w-full max-h-[78vh] object-contain rounded-lg bg-white" />
          )}
          <p className="px-2 pb-1 text-xs text-slate-500">Commercial General Liability — Businessowner Policy. Tap outside to close.</p>
        </DialogContent>
      </Dialog>
    </>
  );
}
